import { render, staticRenderFns } from "./SlsN_Details2.vue?vue&type=template&id=3b1f65ec"
import script from "./SlsN_Details2.vue?vue&type=script&lang=js"
export * from "./SlsN_Details2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports